import socket from '@/plugins/socket'
import Area from '@/store/model/main/Area'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    load: (state, data) => {
      let values = []
      for (const i in data) {
        const areaData = data[i]
        const founded = values.find((area) => { return areaData.id === area.id })
        if (!founded) {
          values.push(new Area(areaData))
        }
      }
      values = values.sort((a, b) => a.nameFr.localeCompare(b.nameFr))
      state.list = values
    }
  },
  actions: {
    init (state) { socket.get('MainArea', 'Main/Area/load') },
    set (state, data) {
      state.state.list = []

      const parameters = {
        joinr: [
          'SportSportCompetition.areaId',
          'SportSportCompetitionseason.competitionId'
        ]
      }

      if (data && data.seasonId && data.seasonId > 0) {
        parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
      }

      socket.get('MainArea', 'Main/Area/load', parameters)
    }
  },
  getters: {
    list: (state) => state.list
  }
}
